<template>
  <div
    ref="bar"
    class="chart"></div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'MallMonthDataChart',
  props: {
    data: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      bar: null
    }
  },
  watch: {
    data() {
      this.initBar()
    }
  },
  mounted() {
    this.initBar()

    window.addEventListener('resize', () => {
      if (this.bar) this.bar.resize()
    })
  },
  beforeDestroy() {
    if (this.bar) this.bar.dispose()
    this.bar = null
  },
  methods: {
    initBar() {
      const color = ['#FFA000', '#1261FF']
      this.bar = echarts.init(this.$refs.bar)
      const option = {
        grid: {
          top: 24,
          right: 48,
          bottom: 40,
          left: 28,
          containLabel: true
        },
        yAxis: {
          type: 'category',
          data: this.data.map(v => v.label),
          axisLine: {
            show: true,
            lineStyle: {
              color: '#999'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#666',
            fontSize: 14,
            margin: 12
          }
        },
        xAxis: {
          type: 'value',
          name: '元',
          nameTextStyle: {
            color: '#999'
          },
          // max: this.max,
          axisLine: {
            show: true,
            lineStyle: {
              color: '#999'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#999',
            fontSize: 12,
            margin: 12
          },
          splitLine: {
            show: false
          }
        },
        series: [{
          data: this.data.map((v, i) => {
            return {
              value: v.value,
              itemStyle: {
                color: color[i % 2],
                barBorderRadius: [0, 4, 4, 0]
              },
              label: {
                show: v.value > 0,
                position: 'right',
                valueAnimation: true,
                textStyle: {
                  fontSize: 12,
                  color: '#666'
                }
              }
            }
          }),
          type: 'bar',
          barMaxWidth: 24
        }]
      }
      this.bar.setOption(option, true)
    }
  }
}
</script>

<style lang="scss" scoped>
.chart {
    width: 100%;
    height: 100%;
}
</style>
